import React from 'react';

import { Control, Controller } from 'react-hook-form';

import { TextField } from '@mui/material';

import { TourOfferBookingTerms } from '~/types/tours/tourOffer';

import { NativeTourForm } from './nativeTourForm';

export type BookingTermsNumberField = keyof Pick<
  TourOfferBookingTerms,
  'depositAmount' | 'depositDueDays' | 'finalPaymentDueDays'
>;

const numberOrNull = (value: string) => (value.trim() === '' ? null : Number(value));
const isNegative = (value: number | null) => value !== null && (Number.isNaN(value) || value < 0);

export default function NativeTourNumberInput({
  control,
  field: name,
  label,
  helperText,
}: {
  control: Control<NativeTourForm>;
  field: BookingTermsNumberField;
  label: string;
  helperText?: string;
}) {
  return (
    <Controller
      control={control}
      name={`bookingTerms.${name}`}
      render={({ field }) => (
        <TextField
          type="number"
          label={label}
          value={field.value ?? ''}
          onChange={(event) => field.onChange(numberOrNull(event.target.value))}
          error={isNegative(field.value)}
          helperText={isNegative(field.value) ? 'Must be 0 or more' : helperText}
          inputProps={{ min: 0 }}
          fullWidth
        />
      )}
    />
  );
}
